import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DatabaseTable } from "../../models/BaseTable";
import Interaction from "../../models/interactions/Interaction";
import { Map } from "immutable";

export interface TableState {
  tables: Map<typeof DatabaseTable, Map<any, DatabaseTable>>;
  accounts: Map<any, Interaction>;
}

export const initialState: TableState = {
  tables: Map(),
  accounts: Map(),
};

interface InsertTableRowPayload {
  table: typeof DatabaseTable;
  id: any;
  data: DatabaseTable;
}

interface UpdateTableRowPayload {
  table: typeof DatabaseTable;
  id: any;
  data: DatabaseTable;
}

interface DeleteTableRowPayload {
  table: typeof DatabaseTable;
  pk: any;
}

const tableSlice = createSlice({
  name: "tables",
  initialState,
  reducers: {
    updateSlice(state, action: PayloadAction<Partial<TableState>>) {
      // Annoying bit of casting because WritatableDraft throws so many ts errors
      const stateData = state as unknown as TableState;
      let key: keyof TableState;
      for (key in action.payload) {
        (stateData[key] as any) = action.payload[key];
      }
      return stateData;
    },
    insertTableRow(state, action: PayloadAction<InsertTableRowPayload>) {
      // Annoying bit of casting because WritatableDraft throws so many ts errors
      const stateData = state as unknown as TableState;

      let tableMap = stateData.tables.get(action.payload.table);
      if (typeof tableMap === "undefined") {
        tableMap = Map();
      }
      stateData.tables = stateData.tables.set(
        action.payload.table,
        tableMap.set(action.payload.id, action.payload.data),
      );
      if (action.payload.table.tableName === "Interaction") {
        const interaction = action.payload.data as Interaction;
        if (interaction.properties.type === "account") {
          state.accounts = state.accounts.set(action.payload.id, interaction);
        }
      }
    },
    updateTableRow(state, action: PayloadAction<UpdateTableRowPayload>) {
      // Annoying bit of casting because WritetableDraft throws so many ts errors
      const stateData = state as unknown as TableState;

      const tableMap = stateData.tables.get(action.payload.table);
      if (typeof tableMap === "undefined") {
        return undefined;
      }

      stateData.tables = stateData.tables.set(
        action.payload.table,
        tableMap.set(action.payload.id, action.payload.data),
      );
      if (action.payload.table.tableName === "Interaction") {
        const interaction = action.payload.data as Interaction;
        if (interaction.properties.type === "account") {
          state.accounts = state.accounts.set(action.payload.id, interaction);
        }
      }
    },
    deleteTableRow(state, action: PayloadAction<DeleteTableRowPayload>) {
      // Annoying bit of casting because WritatableDraft throws so many ts errors
      const stateData = state as unknown as TableState;
      const table = action.payload.table;
      const tableMap = stateData.tables.get(table);
      if (typeof tableMap !== "undefined") {
        stateData.tables = stateData.tables.set(
          table,
          tableMap.delete(action.payload.pk),
        );
      }
      if (table.tableName === "Interaction") {
        stateData.accounts = stateData.accounts.delete(action.payload.pk);
      }
    },
  },
});

export default tableSlice;
export const tableSliceActions = tableSlice.actions;
